/**
 * @generated SignedSource<<4dbcd1f3d688a62997a298364666b223>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateWidgetNoteFromExistingNoteInput = {
  noteId: string;
  positionX: number;
  positionY: number;
};
export type WANoteExistingMutation$variables = {
  storecastId: string;
  widget: CreateWidgetNoteFromExistingNoteInput;
};
export type WANoteExistingMutation$data = {
  readonly dashboard: {
    readonly createWidgetNoteFromExistingNote: {
      readonly id: string;
    };
  };
};
export type WANoteExistingMutation = {
  response: WANoteExistingMutation$data;
  variables: WANoteExistingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widget"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "widget"
          }
        ],
        "concreteType": "WidgetNote",
        "kind": "LinkedField",
        "name": "createWidgetNoteFromExistingNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WANoteExistingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WANoteExistingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "689568798a85cebe43965a673fc84e28",
    "id": null,
    "metadata": {},
    "name": "WANoteExistingMutation",
    "operationKind": "mutation",
    "text": "mutation WANoteExistingMutation(\n  $storecastId: ID!\n  $widget: CreateWidgetNoteFromExistingNoteInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetNoteFromExistingNote(widget: $widget) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8c4d86e0024fe12cd63b718e37f472d";

export default node;
